import {
    GET_ADMIN_PROFILE_OPERATOR_DETAIL_START,
    GET_ADMIN_PROFILE_OPERATOR_DETAIL_ERROR,
    GET_ADMIN_PROFILE_OPERATOR_DETAIL_SUCCESS,
  } from "../Constants/AdminProfileConstant";

const initialState = {
loading: false,
data: [],

};

export default function AdminProfileReducer(
state = { ...initialState },
action
) {
switch (action.type) {
 case GET_ADMIN_PROFILE_OPERATOR_DETAIL_START:
   return {
     ...state,
     loading: true,
   };
 case GET_ADMIN_PROFILE_OPERATOR_DETAIL_SUCCESS:
   return {
     ...state,
     data: action.payload,
     loading: false,
   };
 case GET_ADMIN_PROFILE_OPERATOR_DETAIL_ERROR:
   return {
     ...state,
     loading: false,
     message: action.error.message,
   };

 default:
   return state;
}
}
